function mountSplide(autoPlayOn) {
    var splide = new Splide('.splide', {
        autoplay: autoPlayOn,
        interval: 3000,
        pauseOnHover: true
    });
    
    splide.mount();

    return splide;
}

if(!Shopify.designMode) {
    document.addEventListener('DOMContentLoaded', function() {
        mountSplide(true);
    });
}

if(Shopify.designMode) {
    var fvSlider;

    document.addEventListener('DOMContentLoaded', function() {
        fvSlider = mountSplide(false);
        console.log("slider mounted!");
    });

    document.addEventListener('shopify:section:load', function() {
        fvSlider = mountSplide(false);
        console.log("slider remounted!");
    });

    document.addEventListener('shopify:block:select', function(event) {
        const parent = event.target.parentElement;
        const index = [...parent.children].indexOf(event.target);
        fvSlider.go(index);
    });
}